export default __webpack_public_path__ + "static/media/rmcm04.e9ad0d1a.png";